import {
  TEDSYSBokfarLASTEnum,
  TEDSYSBokfPeriodLASTEnum,
} from '../../../../../../../../globalQueryTypes';
import { getCentury, getYear } from '../../../../../../../../Utils/dateUtils';
import { BokforderWrapperQuery_db_SYSBokfar_All } from '../../../../../Rutiner/Bokforder/Queries/_QueryTypes/BokforderWrapperQuery';

export const parseIncompleteDate = (inCompleteDate: string) => {
  const parsingDate =
    inCompleteDate.length === 5
      ? inCompleteDate.includes('-')
        ? inCompleteDate.split('-')
        : inCompleteDate.includes('/')
        ? inCompleteDate.split('/')
        : []
      : inCompleteDate.length === 7
      ? inCompleteDate.includes('-')
        ? inCompleteDate.split('-')
        : inCompleteDate.includes('/')
        ? inCompleteDate.split('/')
        : []
      : [];

  if (parsingDate.length != 2) {
    return;
  }

  const year: string =
    parsingDate[0].length === 2
      ? `${getCentury(new Date())}` + parsingDate[0]
      : parsingDate[0];
  const month = parsingDate[1];

  const date = new Date(year + '/' + month);

  return date;
};

export const onDateBlur: (
  inputSetter: React.Dispatch<
    React.SetStateAction<{
      value: string;
      isValid: boolean;
    }>
  >
) => (
  event: React.FocusEvent<HTMLDivElement | HTMLInputElement, Element>,
  newValue: string,
  isValidDate: boolean
) => void = inputSetter => (_, newValue, isValidDate) => {
  if (!isValidDate) {
    const suggestionDate = parseIncompleteDate(newValue);

    if (
      suggestionDate &&
      suggestionDate.toLocaleDateString('sv-SE') != 'Invalid Date'
    ) {
      inputSetter({
        value: suggestionDate.toLocaleDateString('sv-SE'),
        isValid: true,
      });
    }
  } else if (isValidDate) {
    const date = new Date(newValue);

    inputSetter({
      value: date.toLocaleDateString('sv-SE'),
      isValid: isValidDate,
    });
  }
};

const getSelectedBfoYear = (
  dateToCheck: Date,
  allBokfar: BokforderWrapperQuery_db_SYSBokfar_All[]
) => {
  return allBokfar.find(year => {
    const bokfar = new Date(year.BOKF_AR);

    return getYear(bokfar) === getYear(dateToCheck);
  });
};

export const isDateinLockedBokfYear = (
  dateToCheck: Date,
  allBokfar: BokforderWrapperQuery_db_SYSBokfar_All[]
) => {
  const selectedYear = getSelectedBfoYear(dateToCheck, allBokfar);

  return selectedYear?.LAST === TEDSYSBokfarLASTEnum.LAST;
};

export const isDateinLockedBokfPeriod = (
  dateToCheck: Date,
  allBokfar: BokforderWrapperQuery_db_SYSBokfar_All[]
) => {
  const selectedYear = getSelectedBfoYear(dateToCheck, allBokfar);

  const selectedPeriod = selectedYear?._Associations?.Bokfperiod_All?.find(
    period => {
      const periodFromDate = new Date(period.FRAN_DATUM);
      const periodToDate = new Date(period.TILL_DATUM);

      return periodFromDate <= dateToCheck && periodToDate >= dateToCheck;
    }
  );

  return selectedPeriod?.LAST === TEDSYSBokfPeriodLASTEnum.LAST;
};
